module.exports = __webpack_public_path__ + "img/6890074fd6348aea.png";